module.exports = __webpack_public_path__ + "static/media/ImporterStep2.9841cd26.svg";